<template>
  <div class="flex gap-2 justify-center items-center">
    <EyeButton name="eye"
      :params="{ asset: props.symbol.name.split('/')[0], exBuy: props.ex_buy.name, exSell: props.ex_sell.name, marketType: props.is_spot ? 'spot-swap' : 'swap' }">
    </EyeButton>
    <Button @click="onEditClick" size="small" as="a" rounded severity="secondary" icon="pi pi-pencil"></Button>
    <Button @click="onDeleteClick" size="small" as="a" rounded severity="secondary" icon="pi pi-trash"></Button>
  </div>
</template>

<script lang="ts" setup>
import EyeButton from ".././EyeButton.vue";
import Button from "primevue/button"
import type { FormInstance } from "@primevue/forms";
import type { ShallowRef } from "vue";
import type { UserMonitoringResponse } from "@/services/monitoring-v2-service/types"
import { useMonitoringStore } from "@/stores/monitoringsStore";

interface ComponentProps extends UserMonitoringResponse {
  form: ShallowRef<FormInstance | null>
}

const props = defineProps<ComponentProps>()
const monitoringStore = useMonitoringStore()

const onDeleteClick = async () => {
  await monitoringStore.deleteMonitoring(props.id)
}

const onEditClick = () => {
  if (!props.form.value) {
    return
  }
  props.form.value.setFieldValue("exBuy", props.ex_buy.name)
  props.form.value.setFieldValue("exSell", props.ex_sell.name)
  props.form.value.setFieldValue("asset", props.symbol.name.split('/')[0])
  props.form.value.setFieldValue("marketType", props.is_spot)
  props.form.value.setFieldValue("spread", props.spread)
  props.form.value.setFieldValue("backspread", props.backspread)
  // emit('set-form-data', props.ex_buy.name, props.ex_sell.name, props.symbol.name, props.is_spot)
}
</script>
